interface MapModel {
    [propName: string]: boolean;
}
const invalidLoginCodeMap: MapModel = {
    100201: true,
    100202: true,
    100203: true
};

export default invalidLoginCodeMap;
